<template>
    <ul class="afu-rounded afu-bg-white afu-shadow-xs afu-list-none afu-py-1 afu-px-0 afu-m-0">
        <li
            v-if="showFirstElement"
            ref="option_-1"
            class="typeahead-item afu-block afu-px-4 afu-py-2 afu-text-sm afu-leading-5 afu-text-black afu-cursor-pointer"
            :class="{ 'afu-bg-neutral-light': arrowCounter === -1 }"
            @click="firstElementClick"
            tabindex="0"
            @mouseover="setArrowCounter(-1)"
        >
            <span
                class="afu-text-neutral-dark afu-pr-2"
            >
                <FontAwesomeIcon :icon="['far', 'plus']" />
            </span>
            {{ keyword }}
        </li>

        <li
            v-for="(opt, index) in options"
            :key="`option_${opt[valueKey]}_${index}`"
            :ref="`option_${index}`"
            :class="{ 'afu-bg-neutral-light': arrowCounter === index }"
            class="typeahead-item afu-block afu-px-4 afu-py-2 afu-text-sm afu-leading-5 afu-text-black afu-cursor-pointer"
            tabindex="0"
            @click="select()"
            @mouseover="setArrowCounter(index)"
        >
            <span
                class="afu-font-normal"
                v-html="opt[`${labelKey}_highlighted`] || opt[labelKey]"
            />
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'C1TypeaheadList',

        props: {
            options: {
                type: Array,
                default: () => [],
            },

            labelKey: {
                type: String,
                default: 'label',
            },

            valueKey: {
                type: String,
                default: 'id',
            },

            keyword: {
                type: String,
                default: '',
            },

            arrowCounter: {
                type: Number,
                default: 0,
            },

            showFirstElement: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
            };
        },

        methods: {
            setArrowCounter(index) {
                this.$emit('update:arrowCounter', index);
            },

            select() {
                this.$emit('select');
            },

            firstElementClick() {
                this.$emit('firstElementClick');
            },
        },
    };
</script>
